var _circle, _circle2, _circle3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTalanginIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#1A3181"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9975,
    cy: 18.0024,
    r: 14.2759,
    fill: "#1E54A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_21150",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 30
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9975,
    cy: 18.0024,
    r: 14.2759,
    fill: "#E19C2A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_21150)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0 39.7267C18.1029 34.7854 27.7714 9.52987 28.8 -2.48022H36V39.7267H0Z",
    fill: "#7698D8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5755 10.8384L22.4341 14.7028L20.4576 16.6823L18.7582 14.9804L18.7596 14.979L18.4035 14.6223L16.6004 12.8165L18.5755 10.8384ZM16.2443 12.4598L18.2193 10.4817L18.5755 10.125L18.9316 10.4817L22.7902 14.3461L23.1464 14.7028L23.1362 14.713L23.1439 14.7207L25.2948 16.8749L25.651 17.2316L25.6436 17.239L25.6712 17.2667L29.4906 21.0919L29.8467 21.4486L29.4906 21.8053L27.5317 23.7672L27.1755 24.1239L26.8194 23.7672L23 19.942L22.9724 19.9143L21.6737 21.2149L21.6346 21.2541L21.6545 21.2739L21.2983 21.6306L19.149 23.7832L18.7929 24.1399L18.4367 23.7832L14.2074 19.5474L14.2028 19.5428L10.1413 23.6105L9.7851 23.9672L9.42894 23.6105L7.62337 21.8021L7.26721 21.4454L7.62337 21.0887L15.8856 12.8139L16.2417 12.4572L16.2443 12.4598ZM17.0644 16.6768L17.069 16.6815L18.7714 18.3864L18.8105 18.3473L20.1091 17.0467L20.1014 17.039L18.4021 15.3371L17.0644 16.6768ZM16.2404 13.172L7.97954 21.4454L9.7851 23.2537L18.0459 14.9804L16.2429 13.1746L16.2404 13.172ZM24.9387 17.2316L22.7877 15.0774L19.1666 18.704L21.3176 20.8582L24.9387 17.2316ZM29.1344 21.4486L25.315 17.6234L23.3561 19.5853L27.1755 23.4105L29.1344 21.4486ZM16.7128 17.0382L20.9421 21.2739L18.7929 23.4265L14.5636 19.1907L16.7128 17.0382Z",
    fill: "#FAEFE2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTalanginIcon);
export default __webpack_public_path__ + "static/media/talangin-icon.60dad833fe3bad45c0276252b3d80d3f.svg";
export { ForwardRef as ReactComponent };